import { ICommunityThreadSaveRequest } from '@/interfaces/community/ICommunityThread.ts';
import { IAdminSparkContent, emptyAdminSparkContent } from '@/interfaces/deltaGpt/IDocument.ts';

export function createRichContentDocument (documentShortCode: string, payload: ICommunityThreadSaveRequest): IAdminSparkContent {
    return {
        ...emptyAdminSparkContent,
        reportType: payload.reportType,
        publicationDate: payload.publicationDate,
        documentTitle: payload.title,
        documentSubtitle: payload.subtitle ?? '',
        documentShortCode,
        authors: payload.authors,
        filters: [],
        description: payload.description,
        bodyHtml: payload.bodyHtml,
        externalUrl: '',
        linkedinUrl: payload.linkedinUrl?.trim() ?? '',
        linkedinEmbedUrl: payload.linkedinEmbedUrl?.trim() ?? '',
        isDraft: payload.isDraft,
        publishAt: payload.publishAt ?? '',
        access: payload.access,
        routeNames: payload.pageLinks.map(pageLink => pageLink.routeName),
        siteAreaRelevance: payload.siteAreaRelevance,
        richTextImages: payload.richTextImages,
    };
}
